<div class="map-container">
    <google-map 
        #map
        height="90%"
        width="100%"
        [zoom]="zoom ? zoom : 4"
        [center]="{ lat: latitude ? latitude : 9.1021111, lng: longitude ? longitude : 18.2811944 }"
        [options]="{
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true
            }"
        >
    </google-map>

    <div id="streetview-small" [class.hide]="!isStreetViewVisible" #streetviewSmall>
        <div class="text">{{'NO_STREET_VIEW_AVAILABLE' | translate}}</div>
        <div (click)="isStreetViewVisible = false" class="x-container"><img src="../../../assets/icons/close.svg" alt="Close icon" /></div>
    </div>

    <div class="footer">
        <button class="btn btn-primary" (click)="saveMapConfiguration()">Save configuration</button>
    </div>
</div>

